import { MenuItem, MenuItemProps } from '@chakra-ui/react';
import React, { forwardRef } from 'react';

const KS_MenuItem = (props: MenuItemProps, ref: any) => {
  return <MenuItem {...props} ref={ref} />;
};

export default forwardRef(KS_MenuItem);
